import React from 'react';
import { TagModel } from '../../../api';

//  Style
import cx from 'classnames';
import './Chip.scss';

type ChipProps = {
    className?: string;
    key?: TagModel;
    text?: string;
};

export const Chip = ({ className, key, text }: ChipProps) => {
    return (
        <div className={cx('chip', className)} key={key?.tagId}>
            {text}
        </div>
    );
};

export default Chip;
